import { useState } from 'react'
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import Button from 'components/formElements/Button'
import { PropTypes } from 'prop-types'
import { useParams } from 'react-router-dom'
import { useRequest } from 'hooks/useRequest'
import { setBillsData } from 'redux/features/projectDetail/projectDetailSlice'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment';
import useToast from 'hooks/useToast'
import { currencyTypes, responsibleRoles, sourceTypes } from 'utils/Constants';
import { Dialog } from 'primereact/dialog';
import InvoiceApprovalModalContent from 'components/modalContent/InvoiceApprovalModalContent';
import { useFileReader } from 'hooks/useFileReader';

const IyzicoBill = (props) => {
    const { projectId } = useParams()
    const [getBillsData] = useRequest()
    const [request, requestLoading] = useRequest()
    const { showToast } = useToast()
    const { projectDetail } = useSelector((state) => state)
    const [invoiceApprovalModal, setInvoiceApprovalModal] = useState({ open: false, text: '', setter: null, invoiceStatusId: null })
    const [filesData, setFilesData, convert] = useFileReader()
    const { ongoingData, invoiceStatuses } = projectDetail
    const dispatch = useDispatch()
    const [formData, setFormData] = useState({
        projectId: Number(projectId),
        sourceType: sourceTypes.TURNKEY,
        responsibleRole: null,
        sourceId: ongoingData.id,
        percent: null,
        currency: ongoingData?.currency,
        amount: null,
        invoiceStatusId: 3,
        name: null,
        estimatedDate: null,
        actualDate: null,
        invoiceDate:null,
        invoiceNo: '',
        description:''

    })
    const handleCloseApprovalModal = () => {
        setInvoiceApprovalModal({ open: false, text: '', setter: null, invoiceStatusId: null })
        setFormData(prev => ({ ...prev, invoiceStatusId: invoiceApprovalModal.invoiceStatusId }))
    }
    const handleApproved = () => {
        if (invoiceApprovalModal.invoiceStatusId == 1) {
            setFormData(prev => ({ ...prev, actualDate: moment().add(3, 'hours').toISOString(), invoiceStatusId: invoiceApprovalModal.invoiceStatusId }))
            handleCloseApprovalModal()
        }
        if (invoiceApprovalModal.invoiceStatusId == 2) {
			if (!formData.estimatedDate) {
				showToast('Kesilecek Ay/Yıl seçimini yapınız','error')
			}else {
				setFormData(prev => ({ ...prev, invoiceStatusId: invoiceApprovalModal.invoiceStatusId }))
				handleCloseApprovalModal()
			}
		}
		if (invoiceApprovalModal.invoiceStatusId == 7) {
			if (!formData.description || !formData.invoiceNo) {
                showToast('Fatura Numarası ve Açıklama giriniz','error')
            } else {
            setFormData(prev => ({ ...prev, invoiceStatusId: invoiceApprovalModal.invoiceStatusId }))
            handleCloseApprovalModal()
            }
		}
    }
    const handleChange = (value, name) => {
        if (name == 'files') {
            convert(value)
        } else if (name == 'percent' && ongoingData?.budget) {
            const amountData = Number(ongoingData?.budget) / 100 * Number(value)
            setFormData((prev) => ({ ...prev, [name]: value, amount: amountData.toFixed(0) }))
        } else if (name == 'invoiceStatusId') {
            if (value == 1) {
                setInvoiceApprovalModal({ open: true, invoiceStatusId: value, text: 'Ödeme tarihini bugün olarak güncellemek ister misiniz?' })
            } else if (value == 2) {
                setInvoiceApprovalModal({ open: true, invoiceStatusId: value, text: 'Ödeme Onayı Belgesi' })
            } else if (value == 7) {
                setInvoiceApprovalModal({ open: true, invoiceStatusId: value, text: 'Fatura No ve Ödeme Onayı Belgesi' })
            } else {
                setFormData((prev) => ({ ...prev, [name]: value }))
            }
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }))
        }
    }
    const removeFile = (file) => {
        setFilesData(prev => ([...prev.filter(f => f.fileName != file.fileName)]))
    }

    const closeDialogFunc = () => {
        props.onHide(false)
    }
    const addBillFunc = () => {
        if (!ongoingData?.budget) {
            showToast('Fatura kalemi eklemek için lütfen bütçeyi giriniz.', 'error')
        } else if (!formData.name) {
            showToast('Proje Adımı Giriniz', 'error')
        } else if (!formData.responsibleRole) {
            showToast('Sorumlu Kişiyi Seçiniz', 'error')
        }else if (formData.invoiceStatusId == 2 && !formData.estimatedDate) {
			showToast('Kesilecek Ay/Yıl seçimini yapınız','error')
		} else {
            const formDatas = new FormData()
            formDatas.append("SourceType", sourceTypes.TURNKEY);
            formDatas.append("SourceId", formData.sourceId);
            formDatas.append("Name", formData.name);
            formDatas.append("ProjectId", formData.projectId);
            formDatas.append("ResponsibleRole", formData.responsibleRole);
            formDatas.append("Percent", formData.percent);
            formDatas.append("Currency", formData.currency);
            formDatas.append("Amount",formData.amount);
            formDatas.append("EstimatedDate", formData.estimatedDate);
            formDatas.append("ActualDate", formData.actualDate);
            formDatas.append("InvoiceDate", formData.invoiceDate);
            formDatas.append("InvoiceStatusId", formData.invoiceStatusId);
            formDatas.append("InvoiceNo", formData.invoiceNo);
            formDatas.append("Description", formData.description);
            filesData?.forEach(f => {
                formDatas.append('File', f.file)
            })
            request('/Invoices/AddInvoices', {
                method: 'POST',
                data: formDatas,
            }).then((res) => {
                if (res.data.ok) {
                    getBillsData('/Invoices/GetInvoiceProjectByAndSourceId', {
                        method: 'GET',
                        params: { projectid: projectId, sourceid: ongoingData.id },
                    }).then(res => {
                        if (res.data.ok) {
                            const data = res.data.result
                            showToast('Fatura Bilgisi Kaydedildi.', 'success')
                            dispatch(setBillsData(data))
                            setFilesData([])
                            closeDialogFunc()
                        }
                    })
                } else {
                    showToast('Bir Sorun Oluştu', 'error')
                }
            })
        }

    }

    return (
        <div className='w-100 d-flex flex-column gap-3 approval-modal-content'>
            <Dialog draggable={false} visible={invoiceApprovalModal.open} onHide={handleCloseApprovalModal}>
                <InvoiceApprovalModalContent filesData={filesData} formData={formData} removeFile={removeFile} handleChange={handleChange} handleClose={handleCloseApprovalModal} approvalModal={invoiceApprovalModal} handleApproved={handleApproved} />
            </Dialog>
            <div className="row">
                <div className='col-md-12'>
                    <div className='form-control'>
                        <input className='default-input' placeholder='Fatura Adımı' name='name' type='text' onChange={(e) => handleChange(e.target.value, 'name')} />
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-6'>
                    <div className='form-control'>
                        <Dropdown placeholder='Sorumlu Kişi' value={formData.responsibleRole && formData.responsibleRole} options={responsibleRoles} onChange={(e) => handleChange(e.value, 'responsibleRole')} />
                    </div>
                </div>
                <div className="col-md-6">
                    <Dropdown
                        optionLabel='label'
                        optionValue='value'
                        placeholder='Fatura Durumu'
                        value={formData?.invoiceStatusId && formData.invoiceStatusId}
                        options={invoiceStatuses?.filter(s => (!s.label.includes('Ödendi') && !s.label.includes('Kesildi')))}
                        onChange={(e) => { handleChange(e.value, 'invoiceStatusId') }}
                    />
                </div>
            </div>
            <div className='row'>
                <div className='col-md-6'>
                    <div className='form-control'>
                        <Calendar
                            view="month" 
							dateFormat="mm/yy"
                            placeholder='Kesilecek Ay'
                            value={formData?.estimatedDate && moment(formData?.estimatedDate).locale('en')._d}
                            name='estimatedDate'
                            onChange={(e) => {
                                handleChange(moment(e.target.value).add(3, 'hours').toISOString(), 'estimatedDate')
                            }}
                        />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className='form-control'>
                        <InputNumber placeholder='Ödeme Yüzdesi' max={100} value={formData?.percent} mode="decimal" onBlur={e => handleChange(e.target.value, 'percent')} name='percent' onChange={(e) => handleChange(e.value, 'percent')} />
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-6'>
                    <div className='form-control'>
                        <InputNumber mode="decimal" minFractionDigits={2} placeholder='Tutar' name='amount' value={formData.amount} onChange={(e) => handleChange(e.value, 'amount')} />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className='form-control'>
                        <Dropdown placeholder='Para Birimi' value={formData?.currency && formData.currency} optionLabel='label' optionValue='value' options={currencyTypes} onChange={(e) => handleChange(e.value, 'currency')} />
                    </div>
                </div>
            </div>
            <div className='row justify-content-center'>
                <div className='col-md-3'>
                    <Button handleClick={addBillFunc} disabled={requestLoading} className='btn-success w-100 justify-content-center' title={'Ekle'} />
                </div>
                <div className='col-md-3'>
                    <Button
                        handleClick={() => closeDialogFunc()}
                        className='btn-danger-outline w-100 justify-content-center'
                        title={'Vazgeç'}
                    />
                </div>
            </div>
        </div>
    )
}
IyzicoBill.propTypes = {
    onHide: PropTypes.func
};
export default IyzicoBill
